import { render, staticRenderFns } from "./GeneratOneTimeAccessKey.vue?vue&type=template&id=058ca040&scoped=true"
import script from "./GeneratOneTimeAccessKey.vue?vue&type=script&lang=js"
export * from "./GeneratOneTimeAccessKey.vue?vue&type=script&lang=js"
import style0 from "./GeneratOneTimeAccessKey.vue?vue&type=style&index=0&id=058ca040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058ca040",
  null
  
)

export default component.exports